const header        = document.querySelector( '.header.offset-top-navigation' );
const topNavigation = document.querySelector( '.top-navigation' );
window.addEventListener( 'scroll', function () {

	if ( topNavigation !== null ) {
		if ( window.scrollY > topNavigation.offsetHeight ) {
			header.classList.add( 'scrolled-past' );
		} else {
			header.classList.remove( 'scrolled-past' );
		}
	}
} );
